// 微信小程序自定义页装修
import {
  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,
  WgtStickyLift,
  WgtStoreRuleList,
  WgtTabsCut,
  WgtGoodsLift,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,
  WgtAroundStoreOne,
  WgtFooterNav,
  WgtFunctionBlock,
  WgtProductShelves,
  WgtCustomWgt,
  WgtLift,
  WgtContentPart,
  WgtImageText,
  WgtArticle,
  WgtClassify,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  wgtCrmMemberActivity,
  WgtMemberTask
} from '../wgts/index'

export const initiWidgets = []

export const widgets = {
  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,
  WgtAbtest,

  WgtStickyLift,
  WgtStoreRuleList,
  WgtTabsCut,
  WgtGoodsLift,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFooterNav,
  WgtFunctionBlock,
  WgtProductShelves,
  WgtCustomWgt,
  WgtLift,

  WgtContentPart,
  WgtImageText,
  WgtArticle,
  WgtClassify,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  wgtCrmMemberActivity,
  WgtMemberTask
}


export default {
  widgets,
  initiWidgets
}
